var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.3984C9.85742 12.3984 12.623 9.62695 12.623 6.26953C12.623 2.91211 9.85156 0.146484 6.5 0.146484C3.14258 0.146484 0.376953 2.91211 0.376953 6.26953C0.376953 9.62695 3.14258 12.3984 6.5 12.3984ZM6.5 11.0215C3.86914 11.0215 1.75977 8.90039 1.75977 6.26953C1.75977 3.63867 3.86328 1.52344 6.5 1.52344C9.13086 1.52344 11.2461 3.63867 11.252 6.26953C11.252 8.90039 9.13086 11.0215 6.5 11.0215ZM5.87891 9.06445C6.10156 9.06445 6.30078 8.94727 6.43555 8.74805L9.05469 4.71094C9.13672 4.58203 9.20117 4.43555 9.20117 4.30078C9.20117 3.98438 8.91992 3.76172 8.61523 3.76172C8.42188 3.76172 8.25195 3.87305 8.11719 4.08984L5.86133 7.68164L4.82422 6.38672C4.68359 6.20508 4.53711 6.14062 4.34961 6.14062C4.03906 6.14062 3.78711 6.38672 3.78711 6.70312C3.78711 6.85547 3.83984 6.99023 3.95117 7.13086L5.29883 8.75391C5.46289 8.95898 5.64453 9.06445 5.87891 9.06445Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2d613265d8c05a5f1164d4d49dc6d548.svg";
export { ForwardRef as ReactComponent };